export default "__VITE_ASSET__65c446b8__"